"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Labels = require("./Labels");
Object.keys(_Labels).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Labels[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Labels[key];
    }
  });
});